import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as d, normalizeClass as o, createElementVNode as n } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconBookmarkPlus",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, i, _, f, a) {
  return l(), d("svg", {
    "aria-label": i.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--bookmark-plus"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Bookmark Plus",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    n("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.5 2a.5.5 0 0 0-.5.5v7.138l2.752-1.572a.5.5 0 0 1 .496 0L9 9.638V2.5a.5.5 0 0 0-.5-.5h-5Zm-1.06-.56A1.5 1.5 0 0 1 3.5 1h5A1.5 1.5 0 0 1 10 2.5v8a.5.5 0 0 1-.748.434L6 9.076l-3.252 1.858A.5.5 0 0 1 2 10.5v-8c0-.398.158-.78.44-1.06ZM6 3a.5.5 0 0 1 .5.5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1A.5.5 0 0 1 6 3Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const k = /* @__PURE__ */ s(c, [["render", u]]);
export {
  k as default
};
//# sourceMappingURL=bookmark-plus.js.map
